export const BASE_FORM_DEFAULTS = {
  allowedLogoImageTypes: ['image/jpeg', 'image/png'],
};
